module.exports = __webpack_public_path__ + "media/entities/1406-920e4b63.png";